<p class="helppoint-title">{{data.title}}</p>
<enum-selector [(ngModel)]="data.incoterm" [enumvalues]="incoterms" [translategroup]="'INCOTERMS'">
</enum-selector>
<div align="end">
    <button mat-raised-button class="helppoint-button confirm" (click)="onConfirm()"
        color="primary">{{'MAINTENANCE.ACCEPT' | translate}}</button>
    <button mat-raised-button class="helppoint-button close" (click)="onClose()"
        color="link">{{'CANCEL.BUTTON' | translate}}</button>
</div>